import StyleSheet from 'react-native-media-query';

import constants from '../../Config/constants';
import ThemeStyle, { globalSpacing } from '../../Theme/styles';
import breakpoints from '../../Theme/styles/breakpoints';

const { ids, styles } = StyleSheet.create({
  contentWrapper: {
    ...ThemeStyle.fitWidthContainer,
    alignSelf: 'center',
    paddingHorizontal: globalSpacing * 2,
    [`@media ${breakpoints.xs}`]: {
      paddingHorizontal: globalSpacing,
    },
  },
  fullWidthWrapper: { width: '100%', paddingHorizontal: '5%' },
  maxWidthWrapper: { maxWidth: constants.PAGE_MAX_WIDTH },
});

export { ids, styles };
